import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash';
import { WORKSPACE_SERVICE_URI } from '../../config/apiConfig';
import { dashboardApiUrlPrefix, insightsApiUrlPrefix } from '../../config/constants';
const mergeDashboardPrefix = `${dashboardApiUrlPrefix}/dashboard-service`;

/**
 * 获取workspace多文件夹的专利数量
 */
export function getWSParentCount(data) {
    return psHttp({
        url: `${mergeDashboardPrefix}/bi-tools/workspace/patent-count`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

export function biToolsPatentCount(data) {
    return psHttp({
        url: `${mergeDashboardPrefix}/bi-tools/patent/count`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

export function getTopicInit() {
    return psHttp({
        url: `${mergeDashboardPrefix}/bi-tools/helper-section?type=TTC`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

export function getTopicSearch({ search = '', start = 0 }) {
    return psHttp({
        url: `${mergeDashboardPrefix}/bi-tools/helper-search`,
        method: 'GET',
        params: { q: search, start, type: 'ttc' },
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

export function getTopicList({ code = '', level = '', start = 0 }) {
    return psHttp({
        url: `${mergeDashboardPrefix}/bi-tools/helper-subclass`,
        method: 'GET',
        params: { type: 'TTC', code, level, start },
        transformCode: true,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

export function createReport(data) {
    return psHttp({
        url: `${mergeDashboardPrefix}/report`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

/**
 * 查询folder
 */
export function searchWorkspaceSelfShareApi({
    // eslint-disable-next-line camelcase
    need_share_space, skip_count, patent_read_only, folder_search_name, need_public_space = true, owner_public_space,
}) {
    return psHttp({
        url: `${WORKSPACE_SERVICE_URI}/workspace/web/space/query-all-list`,
        method: 'POST',
        data: {
            need_share_space,
            skip_count,
            patent_read_only,
            folder_search_name,
            need_public_space,
            owner_public_space,
        },
        headers: { 'X-API-Version': '2.0' },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function searchWorkspaceFolderApi({
    // eslint-disable-next-line camelcase
    folder_search_name = '', space_id,
}) {
    return psHttp({
        url: `${WORKSPACE_SERVICE_URI}/workspace/web/space/search-folder?just_check_read_patent_permit=true&need_folder_collapse=true`,
        method: 'POST',
        data: {
            folder_search_name,
            space_id,
        },
        headers: { 'X-API-Version': '2.0' },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}

// 获取报告模板
export function getReportTemplates(params){
    return psHttp({
        url: `${mergeDashboardPrefix}/template`,
        method: 'GET',
        transformCode: true,
        params,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}

// 使用模版创建报告
export function createReportByTemplate(data) {
    return psHttp({
        url: `${mergeDashboardPrefix}/report-by-template`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

// 创建英策报告
export function createDashboard(param){
    return psHttp({
        url: `${insightsApiUrlPrefix}/dashboard/technology`,
        method: 'POST',
        data: param,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

// 删除报告
export function deleteReport(id) {
    return psHttp({
        url: `${mergeDashboardPrefix}/report/${id}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return _.get(data, 'data', {});
    });
}


// 复制报告
export function reportCopy(param){
    return psHttp({
        url: `${mergeDashboardPrefix}/report/copy`,
        method: 'POST',
        data: param,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
